export const Gamification = "GAMIFICATION";
export const Spif = "SPIF";